import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { PriceOfferCreateBulkPayload } from 'api/actions/price-offer-create-bulk/price-offer-create-bulk-payload';
import { PriceOfferCreateBulkPathParameters } from 'api/actions/price-offer-create-bulk/price-offer-create-bulk-path-parameters';
import { PriceOfferCreateBulkResponse } from 'api/actions/price-offer-create-bulk/price-offer-create-bulk-response';

type PriceOfferCreateBulkQueryParameters = Record<string, any>;

/**
 * The path of the PriceOfferCreateBulk action.
 */
export const priceOfferCreateBulkActionPath = new SweetPath<keyof PriceOfferCreateBulkPathParameters>(
  '/api/price-offer/create-bulk',
  { path: '{param}' }
);

/**
 * Creates a contextualized PriceOfferCreateBulk actions.
 */
export default function createPriceOfferCreateBulkAction(axios: AxiosInstance) {
  return function priceOfferCreateBulkAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: PriceOfferCreateBulkQueryParameters;
    payload: PriceOfferCreateBulkPayload;
  }) {
    const path = priceOfferCreateBulkActionPath.original;

    return axios.request<PriceOfferCreateBulkResponse, PriceOfferCreateBulkResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
